import css from "./AddTaskModal.module.css";
import Form from "../../Components/Form/Form";
import AddTaskOptions from "./AddTaskOptions";
import { useState } from "react";
import Url from "../../Services/Url";
import Utils from "../../Services/Utills";
import { toast } from "react-toastify";
import { ModalAction } from "../../Routes/NavRouter";

const AddTaskModal = ({ children, onNext, task }) => {
	const { closeModal } = ModalAction;

	const [options, setOptions] = useState(AddTaskOptions(task));
	const [saving, setSaving] = useState(false);

	const cancelButton = options.Buttons.find((btn) => btn.text === "Cancel");
	if (cancelButton) {
		cancelButton.onClick = closeModal;
	}

	const onSubmit = (data) => {
		const formData = Utils.FormObject(data);

		const fullLocation =
			`${formData.location}, ${formData.state}, ${formData.country}`.trim();

		const taskDetails = {
			...formData,
			location: fullLocation,
		};

		children.AddTaskModal = taskDetails;
		onNext && onNext(taskDetails);
	};

	return (
		<div className={css.Cont}>
			<div className={css.Head}>
				<h2>Task Details</h2>
			</div>
			<div className={css.Body} style={{ display: saving ? "none" : "flex" }}>
				<Form onSubmit={onSubmit}>{options}</Form>
			</div>
		</div>
	);
};

export default AddTaskModal;
